document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".testimonial-section").forEach((section) => {

    const swiperEl = section.querySelector(".testimonialSwiper");
    if (!swiperEl) return;

    const progress = section.querySelector(".progress-fill");
    const currentSlide = section.querySelector(".current-slide");
    const totalSlide = section.querySelector(".total-slide");

    const swiper = new Swiper(swiperEl, {

      slidesPerView: 1.15,
      spaceBetween: 15,
      speed: 600,
      grabCursor: true,
      watchOverflow: true,

      navigation: {
        nextEl: section.querySelector(".slider-next"),
        prevEl: section.querySelector(".slider-prev")
      },

      pagination: {
        el: section.querySelector(".swiper-pagination"),
        clickable: true,
        dynamicBullets: true,
      },
      breakpoints: {

        768: {
          slidesPerView: 1.2,
        },

        1150: {
          slidesPerView: 2.9,
        },

        1360: {
          slidesPerView: 3.2,
          spaceBetween: 15
        }

      },

      on: {

        init() {
          updateSlider(this);
        },

        slideChange() {
          updateSlider(this);
        },

        resize() {
          updateSlider(this);
        }

      }

    });

    function updateSlider(swiper) {

      let visible = swiper.params.slidesPerView;

      if (typeof visible !== "number") {
        visible = swiper.slidesPerViewDynamic();
      }

      const totalPages = Math.max(
        swiper.slides.length - Math.floor(visible) + 1,
        1
      );

      const currentPage = swiper.activeIndex + 1;

      currentSlide.textContent = String(currentPage).padStart(2, "0");
      totalSlide.textContent = String(totalPages).padStart(2, "0");

      const percentage = (currentPage / totalPages) * 100;

      progress.style.width = percentage + "%";

      const prev = section.querySelector(".slider-prev");
      const next = section.querySelector(".slider-next");

      prev.disabled = swiper.isBeginning;
      next.disabled = swiper.isEnd;

      prev.classList.toggle("disabled", swiper.isBeginning);
      next.classList.toggle("disabled", swiper.isEnd);

    }


    let wheelLock = false;

    swiperEl.addEventListener(
      "wheel",
      function (e) {

        if (wheelLock) {
          e.preventDefault();
          return;
        }

        if (e.deltaY > 0) {

          if (!swiper.isEnd) {

            e.preventDefault();

            wheelLock = true;

            swiper.slideNext();

            setTimeout(() => {
              wheelLock = false;
            }, 500);

          }

        } else {

          if (!swiper.isBeginning) {

            e.preventDefault();

            wheelLock = true;

            swiper.slidePrev();

            setTimeout(() => {
              wheelLock = false;
            }, 500);

          }

        }

      },
      { passive: false }
    );

  });

});